import React from 'react';
import './style/Promotion.css';
import promotion1 from './store_pictures/promotion1.jpg';
import promotion2 from './store_pictures/promotion2.jpg';
import promotion3 from './store_pictures/promotion3.jpg';

const Promotion = () => {
    return (
        <div className="promotion">
            <div className="promotion-left-container">
                <div className="promotion-promotion-discount" style={{ backgroundImage: `url(${promotion1})` }}>
                    <span className="promotion-discount-text">-25%</span>
                    <span className="promotion-discount-subtext">на фрукты</span>
                </div>
                <div className="promotion-info-block1" style={{ backgroundImage: `url(${promotion2})` }}>
                    <span className="promotion-info-text1">Соберём и доставим</span>
                    <span className="promotion-info-subtext1">Начнём собирать ваш заказ сразу же после оформления</span>
                </div>
            </div>
            <div className="promotion-right-container">
                <div className="promotion-info-block2" style={{ backgroundImage: `url(${promotion3})` }}>
                    <span className="promotion-info-text2">Только свежие продукты</span>
                    <span className="promotion-info-subtext2">на вашем столе</span>
                </div>
            </div>
        </div>
    );
};

export default Promotion;
